import { render, staticRenderFns } from "./MessageOut.vue?vue&type=template&id=1c0a5e6d&scoped=true"
import script from "./MessageOut.vue?vue&type=script&lang=js"
export * from "./MessageOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a5e6d",
  null
  
)

export default component.exports